( function () {
	'use strict';

	function CreateNewTemplateCtrl ( logger, $modal, $location, templateView ) {
		var self = this;

		function redirectTemplate ( data ) {
			templateView.setViewOnly( false );
			$location.path( '/template/' + data.id );
		}

		function openCreateTemplateModal () {
			$modal.open( {
				'templateUrl'  : '/templates/templates/create-new/create-new-modal.html',
				'controller'   : 'CreateNewTemplateModal',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'resolve'      : {}
			} ).result.then( redirectTemplate );
		}

		function activate () {
			logger.info( 'Activated Create New Template Button' );
		}

		activate();

		self.openCreateModal = openCreateTemplateModal;
	}

	angular
		.module( 'app.templates' )
		.controller( 'CreateNewTemplateCtrl', CreateNewTemplateCtrl );

	CreateNewTemplateCtrl.$inject = [ 'logger', '$modal', '$location', 'templateView' ];
} )( );
